"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignFromAccountRaw = exports.assignToAccountRaw = exports.fromCryptoOrgResourcesRaw = exports.toCryptoOrgResourcesRaw = void 0;
const bignumber_js_1 = require("bignumber.js");
function toCryptoOrgResourcesRaw(r) {
    const { bondedBalance, redelegatingBalance, unbondingBalance, commissions } = r;
    return {
        bondedBalance: bondedBalance.toString(),
        redelegatingBalance: redelegatingBalance.toString(),
        unbondingBalance: unbondingBalance.toString(),
        commissions: commissions.toString(),
    };
}
exports.toCryptoOrgResourcesRaw = toCryptoOrgResourcesRaw;
function fromCryptoOrgResourcesRaw(r) {
    const { bondedBalance, redelegatingBalance, unbondingBalance, commissions } = r;
    return {
        bondedBalance: new bignumber_js_1.BigNumber(bondedBalance),
        redelegatingBalance: new bignumber_js_1.BigNumber(redelegatingBalance),
        unbondingBalance: new bignumber_js_1.BigNumber(unbondingBalance),
        commissions: new bignumber_js_1.BigNumber(commissions),
    };
}
exports.fromCryptoOrgResourcesRaw = fromCryptoOrgResourcesRaw;
function assignToAccountRaw(account, accountRaw) {
    const crytpoOrgAccount = account;
    if (crytpoOrgAccount.cryptoOrgResources) {
        accountRaw.cryptoOrgResources = toCryptoOrgResourcesRaw(crytpoOrgAccount.cryptoOrgResources);
    }
}
exports.assignToAccountRaw = assignToAccountRaw;
function assignFromAccountRaw(accountRaw, account) {
    const cryptoOrgResourcesRaw = accountRaw.cryptoOrgResources;
    if (cryptoOrgResourcesRaw)
        account.cryptoOrgResources =
            fromCryptoOrgResourcesRaw(cryptoOrgResourcesRaw);
}
exports.assignFromAccountRaw = assignFromAccountRaw;
//# sourceMappingURL=serialization.js.map